import React, { useMemo } from 'react';
import { Container, Sprite } from '@pixi/react';

import { getGameImages } from '../../../core/helpers/getGameImages';

function GameLogo({ containerConfig }) {
  const { gameLogo } = useMemo(() => {
    return getGameImages();
  }, []);

  return (
    <Container {...containerConfig} name='GameLogoContainer'>
      <Sprite texture={gameLogo} />
    </Container>
  );
}

export default GameLogo;
